import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'

import { Policy, PolicyConferenceRules } from 'src/types'
import { Select } from 'src/components/Formik'

import * as Reduce from './reduces'

interface Props {
  formikProps: FormikProps<PolicyConferenceRules>
  policies: Policy[]
}

export default function SelectPolicyExceptionGroup({
  formikProps,
  policies
}: Props) {
  const receiptRulesOptions = policies.reduce(Reduce.receiptRules, [])

  return (
    <Row gutter={24}>
      <Col span={10}>
        <Select
          dataTestId="policy-request-general-rule-id-list"
          formikProps={formikProps}
          label="web.policies.rules.receipt.title"
          name="policy_request_general_rule_id"
          options={receiptRulesOptions}
          placeholder="common.actions.select"
          required={false}
        />
      </Col>
    </Row>
  )
}
